export interface CachedValue {
  value: string | number | object
  type: string
}

export class BrowserCache {
  public available: boolean = false
  private cache!: Storage
  private clearingCache: boolean = false

  private keys = {
    shift: false,
    ctrl: false,
    x: false
  }

  constructor(addListeners: boolean = false) {
    if ('localStorage' in window) {
      this.available = true
      this.cache = window.localStorage
    }
  }

  async clear() {
    if (this.keys.shift && this.keys.ctrl && this.keys.x && !this.clearingCache) {
      this.clearingCache = true
      this.cache.clear()
      // sleep?
      console.log('cache cleared')
      this.clearingCache = false
    }
  }

  get<R>(key: string): R | null {
    if (!this.available) {
      return null
    }
    const cached = this.cache.getItem(key)
    if (cached != null) {
      const cachedValue: CachedValue = JSON.parse(cached)
      return cachedValue as any as R
    }
    return null
  }

  add(key: string, value: string | object | number | boolean): void {
    if (this.available) {
      this.cache.setItem(key, JSON.stringify(value))
    }
  }

  remove(key: string): void {
    if (this.available && this.cache.getItem(key) !== undefined) {
      this.cache.removeItem(key)
    }
  }
}
